import {
  apiURL
} from '../../config/app';

const updateProfile = async ({ authToken, payload }) => {
  const response = await fetch(`${apiURL}/profile`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const changePassword = async ({ authToken, payload }) => {
  const response = await fetch(`${apiURL}/change-password`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

export default {
  updateProfile,
  changePassword
};



// WEBPACK FOOTER //
// ./api/profile.js